import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Sector, SectorCollection } from '../interfaces';
import { ApiService } from './api.service';

export type SectorFilters = {
  nom?: string;
  order_by?: string;
  order?: string;
  page?: number;
  size?: number;
  fields?: {
    secteurs?: string;
  }
  [x: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SectorService extends ApiService {

  public get(id: string | number, filters: SectorFilters = {}): Observable<Sector> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<Sector>(`${this.apiUrl}/secteurs/${id}${queryString}`)
  }

  public getCollection(filters: SectorFilters = {}): Observable<SectorCollection> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<SectorCollection>(`${this.apiUrl}/secteurs/${queryString}`)
  }

  public post(data: Partial<Sector>, filters: SectorFilters = {}): Observable<Sector> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.post<Sector>(`${this.apiUrl}/secteurs/${queryString}`, data)
  }

  public patch(id: string | number, data: Partial<Sector>, filters: SectorFilters = {}): Observable<Sector> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.patch<Sector>(`${this.apiUrl}/secteurs/${id}${queryString}`, data)
  }

  public delete(id: string | number): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/secteurs/${id}`)
  }
}
